import _ from 'lodash';

// 影響を管理するクラス
// fieldstree.htmlで使用
export function effectManager(target_selecter, split_ids, tags) {
  this.target = document.querySelector(target_selecter);
  this.split_ids = split_ids;
  this.tags = tags;

  if (!this.target || !_.isArray(this.tags) || !_.isArray(this.split_ids)) {
    throw new Error('引数の値が間違ってます。');
  }
}

effectManager.prototype = {
  result: null,
  beforeCallback() {},

  before(callback) {
    var _this = this;
    this.result = null;
    callback(function(defaultValue) {
      _this.result = defaultValue;
    });

    return this;
  },

  subAffect(callback) {
    var _this = this;
    if (this.result === null) {
      this.result = window.innerWidth;
    }

    _.each(this.split_ids, function(id, i) {
      _this.result -= callback(
        { element: document.querySelector(id), id, tag: _this.tags[i] },
        _this.result,
        _this.target
      );
    });

    return this;
  },

  addAffect(callback) {
    var _this = this;
    if (this.result === null) {
      this.result = window.innerWidth;
    }

    _.each(this.split_ids, function(id, i) {
      _this.result += callback(
        { element: document.querySelector(id), id, tag: _this.tags[i] },
        _this.result,
        _this.target
      );
    });

    return this;
  },

  affect(callback) {
    var _this = this;
    if (this.result === null) {
      this.result = window.innerWidth;
    }

    _.each(this.split_ids, function(id, i) {
      _this.result = callback(
        { element: document.querySelector(id), id, tag: _this.tags[i] },
        _this.result,
        _this.target
      );
    });

    return this;
  },

  done(callback) {
    callback(this.target, this.result);
    return this;
  },
};



// WEBPACK FOOTER //
// ./src/utilities/effectManager.js